module.exports = __webpack_public_path__ + "62844373f55806a84eed476bd946ad81.MP3";